module.exports = __webpack_public_path__ + "files/0c4c5fc7142bf8a4a6050971ccbdad56.png";